<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Repositories from '@/repositories';
const ImportationsRepository = Repositories.get('importations');

export default {
  components: {
    Loading,
  },
  props: {
    workOrderIdPublic: String,
  },
  data() {
    return {
      isLoading: false,
      file: null,
    };
  },
  methods: {
    modalHidden() {
      this.file = null;
      this.isLoading = false;
      this.$emit('modal-closed');
    },
    modalShown() {
      this.file = null;
      this.isLoading = false;
    },
    submitFile() {
      if (this.file != null) {
        this.isLoading = true;

        /* Initialize the form data */
        let formData = new FormData();

        /* Add the form data we need to submit */
        for (let i = 0; i < this.file.length; ++i) {
          formData.append('file', this.file[i]);
        }

        ImportationsRepository.actions
          .workOrdersImport(formData)
          .then(() => {
            this.isLoading = false;
            this.$toast.successToast(this.$t('general.success'));
            this.$bvModal.hide('excel-import-modal');
          })
          .catch(() => {
            this.$toast.errorToast(this.$t('errors.errorLoading'));
            this.isLoading = false;
          });
      }
    },
  },
};
</script>

<template>
  <div>
    <b-modal
      id="excel-import-modal"
      scrollable
      size="lg"
      :title="$t('general.import')"
      @shown="modalShown()"
      @hide="modalHidden()"
      ok-variant="danger"
    >
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        color="#f1b44c"
        :width="70"
        :height="70"
        loader="dots"
        :is-full-page="false"
      >
      </loading>
      <div class="container">
        <div class="large-12 medium-12 small-12 cell">
          <b-form-file
            type="file"
            v-model="file"
            :placeholder="$t('general.selectAFile')"
            :drop-placeholder="$t('general.dropFileHere')"
            accept=".xls,.xlsx"
            multiple
          />
          <b-button class="mt-2" v-on:click="submitFile()">{{
            $t('general.submit')
          }}</b-button>
        </div>
      </div>
      <template #modal-footer>
        <b-button
          @click="$bvModal.hide('excel-import-modal')"
          size="sm"
          variant="danger"
        >
          {{ $t('general.close') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>